import api from "./api";

export default {
  mixins: [ api ],
  methods: {
    // Получение списка исполнителей
    async getWorkers(data) {
      let params = this.makeSearchParams(data);
      let sorting = this.makeSortParams(data);

      if (data.town > 0) {
        params.set("town", data.town);
      }

      if (data.active) {
        params.set("active", data.active);
      }

      if (data.level_efficiency !== '') {
        params.set("level_efficiency", data.level_efficiency);
      }

      if (data.status_id > 0) {
        params.set("status_id", data.status_id);
      }

      return await this.get(`workers?${params.toString()}${sorting}`);
    },
    // Получение исполнителя по id
    async getWorkerById(id) {
      return await this.get(`workers/id/${id}`);
    },
    // Создание исполнителя
    async postWorker(data) {
      return await this.post('workers', data);
    },
    // Изменение исполнителя
    async putWorker(data) {
      return await this.put(`workers/${data.id}`, data);
    },
    // Удаление исполнителя
    async deleteWorker(data) {
      return await this.delete(`workers/${data.id}`, null);
    },

    // Получение расходов исполнителя по id
    async getWorkerCostsById(id) {
      return await this.get(`worker_costs/worker_id/${id}`);
    },
    // Создание расходов исполнителя
    async postWorkerCosts(data, id) {
      return await this.post(`worker_costs/worker_id/${id}`, data);
    },

    // Создание файла паспорта исполнителя
    async postWorkerPassportFile(id, formData) {
      return await this.post(`workers/import/${id}`, formData);
    },
    // Получение файла паспорта исполнителя
    async getWorkerFile(id) {
      return await this.getFile(`workers/id/${id}/passport`, {ignore404: true});
    },

    // Получение последних заявок исполнителя
    async getWorkerLastTasks(id) {
      return await this.get(`workers/id/${id}/last_tasks`);
    },

    // Получение группы медиа исполнителя
    async getWorkerMedia(workerId) {
      return await this.get(`workers/${workerId}/media`);
    },
    // Создание группы медиа исполнителя
    async postWorkerMedia(data) {
      return await this.post(`workers/${data.worker_id}/media`, data);
    },
    // Изменение группы медиа исполнителя
    async putWorkerMedia(data) {
      return await this.put(`workers/${data.worker_id}/media/${data.id}`, data);
    },
    // Удаление группы медиа исполнителя
    async deleteWorkerMedia(data) {
      return await this.delete(`workers/${data.worker_id}/media/${data.id}`, null);
    },

    // Получение списка файлов медиа объекта
    async getWorkerMediaFiles(data) {
      return await this.get(`workers/${data.worker_id}/media/${data.id}/files`);
    },
    // Загрузка файлов медиа объекта
    async getWorkerMediaFileDownload(workerId, mediaId, fileId) {
      return await this.getFile(`workers/${workerId}/media/${mediaId}/files/${fileId}/download`);
    },
    // Создание файлов медиа объекта
    async postWorkerMediaFiles(workerId, mediaId, data) {
      return await this.post(`workers/${workerId}/media/${mediaId}/files`, data);
    },
    // Удаление файлов медиа объекта
    async deleteWorkerMediaFiles(workerId, mediaId, fileId) {
      return await this.delete(`workers/${workerId}/media/${mediaId}/files/${fileId}`, null);
    },
  }
}



// WEBPACK FOOTER //
// ./src/network/workers.js